const removePxSuffix = (value) => {
  // This function removes the `px` suffix that Stylis automatically adds to integer inputs
  if (typeof value === 'string' && value.endsWith('px'))
    return value.slice(0, -2);
  return value;
};

export const lineClampPolyfill = (element) => {
  // Adds vendor prefix for line-clamp
  if (element.type === 'decl' && element.props === 'line-clamp') {
    const formattedValue = removePxSuffix(element.children);
    // We need to create our own concatenated return string
    // element.value already includes the formatted children, making element.children a pretty useless property I guess.
    element.return = `-webkit-${element.props}:${formattedValue}; ${element.props}:${formattedValue};`;
  }
};
